module.exports = __webpack_public_path__ + "static/media/Loss Aversion - francisco-gonzalez-M8UEJd58GcE-unsplash.9f42e123.jpg";